// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetCardContent-EditFab_cls1__s315s","cls2":"VeloModalSheetCardContent-EditFab_cls2__G4Lha VeloModalSheetCardContent-EditFab_cls1__s315s"};